import { getHours, set } from 'date-fns';

/**
 * Generates a Schedule Store Key
 * @param fromCode string
 * @param toCode string
 * @returns string
 */
export const generateScheduleKey = (fromCode: string, toCode: string) => `${fromCode}_${toCode}`;

/**
 * Route Date to Hours
 * @param date Date
 * @param interval number
 * @returns string
 */
export const roundToHours = (date: Date, interval: number) => {
  const hours = getHours(date);
  const roundedHours = Math.floor(hours / interval) * interval;
  return set(date, { hours: roundedHours });
};
